export const mapAuthResponse = (data: any) => ({
  userName: data.name,
  email: data.email,
  displayName: data.name,
  issuedAt: '',
  expiresAt: data.expires_in,
  access_token: data.access_token,
  refresh_token: data.refresh_token,
  id_token: data.id_token,
  sub: data.sub,
  token_type: data.token_type,
  token_fetched_at: Date.now(),
})
